import { createFileRoute } from '@tanstack/react-router';
import { RedditSeoFinderPage } from '../../../pages/tools/reddit-seo-finder/RedditSeoFinderPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/reddit-seo-finder')({
  head: () => toolHead('reddit-seo-finder'),
  component: RedditSeoFinderPage,
});
